import { createContext } from 'react';
import type { AIContextValue } from '@/types';

export const AIContext = createContext<AIContextValue | null>(null);
